/**
 * Validates a media URL (embed_url or image url) before it's used as an <iframe>/<img> `src`.
 * Third-party vendor content (e.g. Forethought) — https-only, no host allowlist yet.
 */
export function isAllowedMediaUrl(url: string): boolean {
  try {
    return new URL(url).protocol === "https:";
  } catch {
    return false;
  }
}
